import React, { useRef } from "react";
import { connect } from "react-redux";
import SvgMask from "../../_svg/Mask";
import { withTranslation } from 'react-i18next';

const App = (props) => {
  const { t, indicator, dispatch } = props
  const ref = useRef();
  const content = {
    title: t('logiciels.cc.mask'),
    description: t('logiciels.cc.mask.description')
  }

  return (
              <div className={"svg-container"} id="svg-mask" itemScope itemType="https://schema.org/WebPage">
                  <div>
                    <SvgMask fill={"#31c6b3"}/>
                    <h3 itemProp="alternativeHeadline">{content.title}</h3>
                    <span itemProp="description">
                        {content.description}
                    </span>
                  </div>
              </div>
  );
};

function mapStateToProps(state) {
  const { indicator } = state;

  return {
    indicator,
  };
}

const connectedCrystalcloud = connect(mapStateToProps)(App);
const tr = withTranslation()(connectedCrystalcloud);
export default tr;
